export const SET_PROVIDERS_FOR_ORGANIZATION = 'SET_PROVIDERS_FOR_ORGANIZATION';

export const SET_ADMINS_FOR_ORGANIZATION = 'SET_ADMINS_FOR_ORGANIZATION';

export const SET_PROVIDER_PERMISSIONS_FOR_ORGANIZATION = 'SET_PROVIDER_PERMISSIONS_FOR_ORGANIZATION';

export const REMOVE_PROVIDERS = 'REMOVE_PROVIDERS';